import { faEdit } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import { useEffect, useState } from "react";
import { sxSubTitle } from "../../../../assets/styles/CommonSxProps";
import DefaultButton from "../../../../components/Accessibility/DefaultButton";
import DefaultTable from "../../../../components/Accessibility/DefaultTable";
import TableBold from "../../../../components/Accessibility/DefaultTable/TableBold";
import TableRegular from "../../../../components/Accessibility/DefaultTable/TableRegular";
import TypographyAccessibility from "../../../../components/Accessibility/TypographyAccessibility";
import VoltarButton from "../../../../components/Accessibility/VoltarButton";
import { StepProps } from "../../../../interfaces/entities/SaudeBemEstar/GestaoDeCronicos/StepProps";
import { useAccessibility } from "../../../../Store/contexts/AccessibilityContext";
import { getBenef } from "../../../../Store/storages/BeneficiarioStorage";
import { getDayNameExtenso } from "../../../../utils/DateFormat";
import { UserData } from "../../PrimeiroAgendamento/AgendarAtendimento/ConfirmarDados";
import ContatoModal from "../../PrimeiroAgendamento/AgendarAtendimento/ConfirmarDados/ContatoModal/ContatoModal";

const StepConfirmacao: React.FC<StepProps> = ({ backStep, openModalError, doctor, horario, confirmSchedule }) => {

  const acessibility = useAccessibility();

  const [userData, setUserData] = useState<UserData | null>(null);
  const [showContactModal, setShowContactModal] = useState<boolean>(false);

  useEffect(() => {
    setUserData(getBenef());
  }, []);

  const onSaveModal = (data: UserData) => {
    setUserData(data)
  }

  const dataAgendamento = [
    [<TableBold text="Profissional" />, <TableRegular text={doctor?.nome || ''} />],
    [<TableBold text="Especialidade" />, <TableRegular text={doctor?.descrEspec || ''} />],
    [<TableBold text="Horário" />, <TableRegular text={`${horario?.data} - ${getDayNameExtenso(moment(horario?.data, 'DD/MM/YYYY').day())} às ${horario?.hora}`} />]
  ]

  const dataContato = [
    [<TableBold text="Telefone" />, <TableRegular text={userData?.tel || '-'} />],
    [<TableBold text="Celular" />, <TableRegular text={userData?.cel || '-'} />],
    [<TableBold text="Email" />, <TableRegular text={userData?.email || '-'} />]
  ]

  return (
    <>
      <div className='feature-container'>
        <TypographyAccessibility sx={sxSubTitle} component={'h2'} style={{color: '#383838'}}>Confirmação da reserva do agendamento</TypographyAccessibility>
        <div className="confirmar-dados-table" style={{ width: '100%' }}>
          <DefaultTable
            data={dataAgendamento}
            columnWidths={['25%', '75%']}
          />
        </div>
        <TypographyAccessibility sx={sxSubTitle}>Confirme seus dados de contato</TypographyAccessibility>
        <div className="confirmar-dados-table" style={{ width: '100%' }}>
          <DefaultTable
            data={dataContato}
            headers={["Dados de contato"]}
            columnWidths={['25%', '75%']}
          />
        </div>
        <div className="flex-row">
          <button
            className="editar-contato-button"
            onClick={() => setShowContactModal(true)}
            style={acessibility.textStyleAccessibility}
          >
            <FontAwesomeIcon icon={faEdit} color="#00995D" style={{...acessibility.contrastStyle, marginRight: '5px'}} />
            Alterar dados de contato
          </button>
        </div>
        <DefaultButton text="Confirmar" onClick={() => confirmSchedule!(userData!)} disabled={!userData} />
        <VoltarButton onClick={backStep} />
      </div>
      <ContatoModal
        open={showContactModal}
        onClose={() => setShowContactModal(false)}
        onSave={onSaveModal}
        userData={userData || { cel: '', tel: '', email: '' }}
      />
    </>
  )
}

export default StepConfirmacao;